import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CCol,
  CRow,
} from '@coreui/react-pro'
import { FaCheck } from 'react-icons/fa'
import React from 'react'

const curricullum = [
  {
    title: 'PRE - SEASON',
    body: 'Cover basic software engineering principles: variables, functions, loop statements, if statements, basic algorithms and data structures. Begin using an IDE and the terminal. This track is the equivalent of a coding bootcamp.',
    languages: 'Languages: Python',
  },
  {
    title: 'SEASON ONE ARC 1',
    body: 'Cover fundamental computer programming concepts and learn the basics of C. Build a solid foundation in back-end programming including pointers, arrays, strings, algorithms, data structures, data types, and software architecture.',
    languages: 'Languages: C',
  },
  {
    title: 'SEASON TWO - DATA SCIENCE',
    body: 'Learners move on to Python and the fundamentals of machine learning, covering regressions, training sets, structured vs unstructured data, and data collection, display, and storage. Learners also cover some of the cloud-based tools available for ML.',
    languages: 'Track tech stack: Python Pytorch Jupyter',
  },
  {
    title: 'SEASON THREE - DATA SCIENCE',
    body: 'After getting a handle on Python, learners advance deeper into machine learning, large/ complex data sets, business principles and the use of data to improve key business outcomes, and how data can be a strategic asset to a business. Learners complete multiple real-world, larger projects.',
    languages: 'Track tech stack: Python, Panda, Tensor Flow, Keras, Jupyter',
  },
  {
    title: 'SEASON TIPP',
    body: 'Learners complete a final program project that aligns with the industry in which they want to get a job. The project must be about 3 months in duration and of significant technical difficulty. Learners will also contribute to open source projects from Kaggle and simultaneously complete 40 technical interviews.',
    languages: 'Track tech stack: Python, Panda, Tensor Flow, Keras, Jupyter',
  },
]

const DataScienceInfo = () => {
  return (
    <div className="px-2 px-lg-4">
      <div className="course-benefit p-4 my-3">
        <h3 className="mb-3">Jobs</h3>
        <CRow>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Python, Pytorch, R, SQL and noSQL databases, Splunk, Tableau or data visualization
                  tools, Jupyter, Panda.
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Experience building and developing data models, familiarity with the software
                  development cycle, ability to handle complex data sets including collection,
                  storage, extraction, and visualization.
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Problem solving, creativity, strong written and verbal communication, get-it-done
                  attitude
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div className="course-benefit p-4 my-3">
        <h3 className="mb-3">Outsource Global Academy</h3>
        <CRow>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Python, Pytorch, R, SQL and noSQL databases, Splunk, Tableau or data visualization
                  tools, Jupyter, Panda.
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Build multiple data models with large and complex (and unstructured) data sets,
                  collecting, storing, and displaying data with the goal of impacting business
                  decisions, reflective of real data science projects.
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Structured problem solving, creativity, strong written and verbal communication
                  and collaboration skills, get-it-done attitude.
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div className="mt-5 pt-1">
        <h2 className="my-4">Fullstack Program Curriculum</h2>
        <CAccordion activeItemKey={1}>
          {curricullum.map(({ title, body, languages }, index) => (
            <CAccordionItem itemKey={index + 1} key={index}>
              <CAccordionHeader>{title}</CAccordionHeader>
              <CAccordionBody>
                {body}
                <br />
                <strong>{languages}</strong>
              </CAccordionBody>
            </CAccordionItem>
          ))}
        </CAccordion>
      </div>
    </div>
  )
}

export default DataScienceInfo
